import { Vue, Component } from "vue-property-decorator";
import RequestButtonFxd from '@/components/request-button/index.vue';
import RequestButton from '@/components/request-button/parts/request-button.vue';
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue"; // import lottie-vuejs
import TrialButton from '@/components/trial-button/index.vue';

@Component({
  components: {
    RequestButtonFxd,
    RequestButton,
    LottieAnimation,
    TrialButton
  }
})

export default class PageLCRM extends Vue {}